import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'hooks';
import Form from 'components/ui/form';
import Button from 'components/ui/button';
import Input from 'components/ui/input';

interface Props {
  email: string;
  validation: any;
  settings: any;
  onChange: any;
  onReset: () => void;
  goBack: () => void;
}

const PasswordResetFormLegacy: React.FC<Props> = ({
  email,
  settings,
  validation,
  goBack,
  onChange,
  onReset,
}) => {
  const getTranslate = useTranslation();
  const emailInput = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const field = emailInput.current?.querySelector(
      '.ui-input__field'
    ) as HTMLDivElement;

    field.focus();
  }, []);

  const resetPassword = () => {
    if (email) {
      onReset();
    }
  };

  return (
    <div className='auth-form'>
      <Form onSubmit={resetPassword}>
        <div className='auth-form__fields' ref={emailInput}>
          <Input
            id='email'
            label={getTranslate('auth.email.label')}
            placeholder={getTranslate('auth.email.placeholder')}
            value={email}
            onChange={(event) => onChange('email', event.target.value)}
            error={validation && validation.email}
            modern
          />
        </div>
        <div className='auth-form__actions'>
          <Button
            icon='im-Arrow-left-Option-2'
            type='button'
            size='large'
            customClass='page-auth__btn page-auth__btn-back'
            onClick={goBack}
          />
          <Button
            text={getTranslate('auth.reset.button')}
            status='primary'
            type='submit'
            disabled={!email}
            size='large'
            customClass='page-auth__btn ui-button_full-width'
          />
        </div>

        <div className='page-auth__link'>
          <a href={`mailto:${settings.supportEmail}`} className='utils-link'>
            {getTranslate('auth.contact.link')}
          </a>
        </div>
      </Form>
    </div>
  );
};

export { PasswordResetFormLegacy };
